import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, user, profileLoading } = useAuth();
  const location = useLocation();

  console.log("🔒 PrivateRoute:", {
    isAuthenticated,
    loading,
    profileLoading,
    user: !!user,
  });

  // 1) On bloque UNIQUEMENT sur le chargement auth (session)
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p className="text-gray-600">Vérification de votre session…</p>
        </div>
      </div>
    );
  }

  // 2) Si non authentifié -> login
  if (!isAuthenticated || !user) {
    console.log("❌ Non authentifié, redirection vers /login");
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3) ✅ NE PLUS BLOQUER sur profileLoading
  // On laisse la page s’afficher, et chaque module qui a besoin du profil gère profile==null.
  // (Optionnel) petit bandeau discret si le profil charge encore:
  return (
    <>
      {profileLoading ? (
        <div className="w-full bg-amber-50 border-b border-amber-200 text-amber-900 text-xs px-4 py-2">
          Chargement de votre profil…
        </div>
      ) : null}
      {children}
    </>
  );
};
